<template>
  <a
    class="block font-medium p-2 text-xs bg-[#f5d3d2]"
    href="https://dikidi.app/#widget=172742"
  >
    ONLINE ЗАПИС
  </a>
</template>
